<template>
  <div>
    <div class="choose">
     <van-search v-model="searchName" placeholder="用户名/姓名" @search="onSearch"/>
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" 
        @load="loadList">
        <div v-for="item in studentList" :key="item.StudentID" class="xy-list list-flex">
          <div class="lists nowrap">
            <div class="list-name nowrap">{{ item.FullName }}</div>
            <div class="list-mark nowrap">{{ item.ClassName }}</div>
          </div>
          <div>
            <button class="xy-public-btn" @click="look(item)">查看</button>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <manager-details :studenID='studenID' :isShowDetail='isShowDetail' @listenToClose="closeModal"></manager-details>
  </div>
</template>
<script>
import { setTimeout } from "timers";
import xyapi from "@/common/api";
import ManagerDetails from '@/pages/schoolAffairs/views/saStudent/saTeacher/Details'
export default {
  name:'List',
  components: {
    ManagerDetails
  },
  data() {
    return {
      page: 1,
      pageSize: 15,
      studentList: [],
      loading: false, // 是否加载中
      finished: false, // 加载是否完成
      isLoading: false, //是否处于下拉刷新状态
      //搜索
      searchName:'',
      //详情
      isShowDetail:false,
      studenID:0,
    };
  },
  created() {
    
  },
  mounted() {

  },
  methods: {
    onSearch(){
      this.onRefresh();
    },
    async loadList() {
      this.xy.loading();
      let res = await xyapi.get(`${this.$store.state.apiPath}/api/HeadmasterManager/GetStudentPage`, {
        orgID:0,
        pageIndex: this.page,
        pageSize: this.pageSize,
        searchName: this.searchName
      });
      this.xy.unloading();
      if (res.success) {
          let list = res.data.data;
          this.studentList = [...this.studentList, ...list];
          this.loading = false;
          this.page++;
          this.finished =(this.studentList.length >= res.data.totalRecords) ? true : false;
      }
    },

    onRefresh() {
      setTimeout(() => {
        this.studentList = [];
        this.page = 1;
        this.isLoading = false;
        this.loadList();
      }, 500);
    },
    //查看详情
    look(val){
      this.isShowDetail = true;
      this.studenID = val.StudentID;
    },
    closeModal (val) {// 监听子组件关闭事件
      this.isShowDetail =val
    },
  }
};
</script>
<style lang="less" scoped>
.xy-list {
  background: #ffffff;
  height: 150px;
  margin:18px;
  border-radius: 12px;
  padding: 0 18px;
}
.list-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .lists {
    flex: 1;
    padding-right: 80px;
    .cut-line {
      color: #ccc;
      padding: 0 10px
    }
    .list-mark {
      font-size: 24px;
      color: #7f7f7f;
      margin-top: 14px;
    }
    .list-name {
      font-weight: 600;
    }
  }
}

</style>
